// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Un dossier : les projets. Source projects.
 *
 * Fournie par le fondateur le 08/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconProjects = createCustomIcon(
  'IconProjects',
  '0 0 240 240',
  <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M0 1255 l0 -955 1013 0 1013 0 179 597 c98 329 180 604 183 611 3 9 -48 12 -237 12 l-241 0 -2 218 -3 217 -495 3 -495 2 -125 125 -125 125 -332 0 -333 0 0 -955z m690 580 l125 -125 422 0 423 0 0 -95 0 -95 -545 0 -544 0 -14 -47 c-206 -692 -282 -933 -294 -933 -11 0 -13 121 -13 710 l0 710 158 0 157 0 125 -125z" />,
);
